import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import config from './config'

// 运行时把散落的相对 /api 请求改写到后端绝对地址（与 user 项目 env.js 同一思路）：
// /api/xxx -> baseUrl + apiVersion(/v6) + /xxx，同时覆盖 fetch 和 el-upload 用的 XHR。
// 这样 40+ 处写死的 fetch('/api/...') 与 3 处上传 action 无需逐个修改，也不再依赖 .env / devServer 代理。
if (typeof window !== 'undefined' && config.baseUrl) {
  var API_ALIAS = '/api'
  var rewrite = function (url) {
    if (typeof url === 'string' && url.indexOf(API_ALIAS + '/') === 0) {
      return config.baseUrl + config.apiVersion + url.substring(API_ALIAS.length)
    }
    return url
  }
  var rawFetch = window.fetch
  window.fetch = function (input, init) {
    return rawFetch.call(this, typeof input === 'string' ? rewrite(input) : input, init)
  }
  var rawOpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function (method, url, async, user, pass) {
    return rawOpen.call(this, method, rewrite(url), async, user, pass)
  }
}

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')